import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import _ from 'lodash';

//utils
import queries from '../../../utils/queries'

import HomeUser1 from './homeuser1';
import HomeUser2 from './homeuser2';

import UserAut1 from './useraut1';
import UserAut2 from './useraut2';
import AddAut1 from './addaut1';
import AddAut2 from './addaut2';
import VerAut1 from './veraut1';
import VerAut2 from './veraut2';

import UserPerfil1 from './userperfil1';
import UserPerfil2 from './userperfil2';
import AddPerfil1 from './addperfil1';
import AddPerfil2 from './addperfil2';
import VerPerfil1 from './verperfil1';
import VerPerfil2 from './verperfil2';

import UserAutP1 from './userautp1';
import UserAutP2 from './userautp2';

import UserUsu1 from './userusu1';
import UserUsu2 from './userusu2';
import AddUsu1 from './addusu1';
import AddUsu2 from './addusu2';
import VerUsu1 from './verusu1';
import VerUsu2 from './verusu2';

import CambClave1 from './cambclave1';
import CambClave2 from './cambclave2';

import CambClaveOU1 from './cambclaveou1';
import CambClaveOU2 from './cambclaveou2';

class HomeUser extends React.Component{
  state={
    showUser: true,
    showAutorizac: false, addAutorizac: false, verAutorizac: false,
    showPerfil: false, addPerfil: false, verPerfil: false,
    showUsu: false, addUsu: false, verUsu: false,
    showCambClave: false, showAutPerfil: false,
    showCambClaveOU: false,
    permiteUpdate: false, permiteDelete: false,
    argsAdd: {}, errorAdd: [],
    idLista: {},
    lisAutPerfil: [], lisAut: [], lisAutPerfilIni: [], lisAutIni: [],
  }

  validarHandle = (campo1, campo1Val, campo1Sel, campo1Msg,
    campo2, campo2Val, campo2Sel, campo2Msg,
    campo3, campo3Val, campo3Sel, campo3Msg,
    campo4, campo4Val, campo4Sel, campo4Msg,
    campo5, campo5Val, campo5Sel, campo5Msg,
    campo6, campo6Val, campo6Sel, campo6Msg)=>{

    const argsAdd = this.state.argsAdd
    const errors = [];

    if(campo1!=='XXX' && (!campo1 || campo1===campo1Sel)){
      argsAdd[campo1Val] = campo1Sel;
      errors.push({path: campo1Val, message: campo1Msg});
    }
    if(campo2!=='XXX' && (!campo2 || campo2===campo2Sel)){
      argsAdd[campo2Val] = campo2Sel;
      errors.push({path: campo2Val, message: campo2Msg});
    }
    if(campo3!=='XXX' && (!campo3 || campo3===campo3Sel)){
      argsAdd[campo3Val] = campo3Sel;
      errors.push({path: campo3Val, message: campo3Msg});
    }
    if(campo4!=='XXX' && (!campo4 || campo4===campo4Sel)){
      argsAdd[campo4Val] = campo4Sel;
      errors.push({path: campo4Val, message: campo4Msg});
    }
    if(campo5!=='XXX' && (!campo5 || campo5===campo5Sel)){
      argsAdd[campo5Val] = campo5Sel;
      errors.push({path: campo5Val, message: campo5Msg});
    }
    if(campo6!=='XXX' && (!campo6 || campo6===campo6Sel)){
      argsAdd[campo6Val] = campo6Sel;
      errors.push({path: campo6Val, message: campo6Msg});
    }
    this.setState({argsAdd});
    this.setState({errorAdd: errors})
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        // console.log(Object.getOwnPropertyNames(this.state)[i])
        // if(typeof estado === "boolean"){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showUser = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showUser: true})
  }

  showAutorizac = (ev) => {
    ev.preventDefault()
    this.props.allAutorizac.refetch()
    this.estadosFalse()
    this.setState({showAutorizac: true})
  }

  showPerfil = (ev) => {
    ev.preventDefault()
    this.props.allPerfiles.refetch()
    this.estadosFalse()
    this.setState({showPerfil: true})
  }

  showUsu = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showUsu: true})
  }

  showCambClave = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showCambClave: true})
  }

  showCambClaveOU = (ev) => {
    ev.preventDefault()
    this.props.allUsuarios.refetch()
    this.estadosFalse()
    this.setState({showCambClaveOU: true})
  }

  showAutPerfil = (ev) => {
    ev.preventDefault()
    this.props.allPerfiles.refetch()
    this.estadosFalse()
    this.setState({showAutPerfil: true})

    let lisAutPerfil = [];
    let lisAutPerfilIni = []
    let elemento2 = this.state.idLista.autorizac
    elemento2.forEach((elemento, i) => {
      lisAutPerfil.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
        _id: i, estadoAut: true});

      lisAutPerfilIni.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
        _id: i, estadoAut: true});
      })
      lisAutPerfil = _.orderBy(lisAutPerfil, ['codigoAutorizac'])
    // this.ordenarArrayAsc(lisAutPerfil, 'codigoAutorizac')
    this.setState({lisAutPerfil})

    lisAutPerfilIni = _.orderBy(lisAutPerfilIni, ['codigoAutorizac'])
    // this.ordenarArrayAsc(lisAutPerfilIni, 'codigoAutorizac')
    this.setState({lisAutPerfilIni})

    const lisAut = [];
    const lisAutIni = [];
    elemento2 = this.props.allAutorizac.allAutorizac
    elemento2.forEach((elemento, _id) => {
      let siExiste = false
      lisAutPerfil.forEach((elemento1, _id) => {
        if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
          siExiste = true
        }
      })
      if(siExiste===false){
        lisAut.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
          _id: elemento._id, estadoAut: false});

          lisAutIni.push({codigoAutorizac: elemento.codigoAutorizac, descrAutorizac: elemento.descrAutorizac,
          _id: elemento._id, estadoAut: false});
      }
    })

    this.ordenarArrayAsc(lisAut, 'codigoAutorizac')
    this.setState({lisAut})

    this.ordenarArrayAsc(lisAutIni, 'codigoAutorizac')
    this.setState({lisAutIni})
  }

  addAutorizac = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addAutorizac: true})
  }

  addPerfil = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addPerfil: true})
  }

  selCiudad = () => {
    if(this.props.allDirmayor.allDirmayor){
      if(this.props.codigoCiudadUA!=="Todas..."){
        const argsAdd = this.state.argsAdd
        let dptoOK = false
        this.props.allDirmayor.allDirmayor.forEach((elemento, _id) => {
          if(!dptoOK){
            elemento.ciudades.forEach((elemento1, _id) => {
              if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                dptoOK = true
                argsAdd['_idDpto'] = elemento._id
                argsAdd['codigoDpto'] = elemento.codigoDpto
                argsAdd['descrDpto'] = elemento.descrDpto
                argsAdd['codigoCiudad'] = elemento1.codigoCiudad
                argsAdd['nombreCiudad'] = elemento1.nombreCiudad                
                this.setState({argsAdd});
                // console.log(argsAdd)
              }
            })
          }
        })
        // console.log(argsAdd)
      }
      // console.log(lista1)
    }
  }

  addUsu = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addUsu: true})

    this.selCiudad()
  }

  handleChange = (ev, input)=>{
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      if(this.state.addUsu){
        if(!argsAdd.userApp){
          argsAdd.userApp = false
        }
      }
      argsAdd[ev.target.name] = ev.target.value
    }
    //   if(input.type==='checkbox'){
    //   argsAdd[input.name] = input.checked
    // }else{
    //   argsAdd[input.name] = input.value
    // }
    this.setState({argsAdd});
  }

  crudBD = async (operacionCRUD, args, i)=>{
    // console.log("CRUD")
        if(args.ctrlCampo === 'CRUD'){
  // console.log(i)
  // console.log(args)
          const {data} = await operacionCRUD({
            variables: args
          });
    
    //Se utiliza para traer el _id del documento creado
          if(args.ctrl_id === 'SI_ID'){
            if(Object.values(data)[0]._id){
              return Object.values(data)[0]._id
            }else{
              return 0
            }
          }
        }else{
          if(args.ctrlCampo === "MANY"){
            // console.log("MANY")
            // console.log(args)
            await operacionCRUD({
              variables: args
            });
          }
        }
      }

      updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
  // console.log(argsCrud)
  // console.log(totDocCRUD)
        let codigo = 0
        // console.log(argsCrud)
        if(argsCrud[0].ctrl_id === 'SI_ID'){
          codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }else{
          await this.crudBD(crudColecc[0], argsCrud[0], 0)
        }
        if(codigo!==0){
          for(let i=1; i<totDocCRUD; i++){
            argsCrud[i]._id = codigo
          }
        }
  // console.log("inicio")
        for(let i=1; i<totDocCRUD; i++){
          await this.crudBD(crudColecc[i], argsCrud[i], i)
        }
  console.log("final")
      }

      
  handleAutorizac = async (ev, args)=>{
    if(!args.codigoAutorizac||!args.descrAutorizac){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.codigoAutorizac){
        argsAdd['codigoAutorizac'] = "";
        errors.push({path: 'codigoAutorizac', message: "Debe escribir el código"});
      }
      if(!args.descrAutorizac){
        argsAdd['descrAutorizac'] = "";
        errors.push({path: 'descrAutorizac', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addAutorizac){
        const response = await this.props.createAutorizac({
          variables: args
        });
        const {errors, success} = response.data.createAutorizac;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var codigoAutorizac = document.getElementById("codigoAutorizac");
          var descrAutorizac = document.getElementById("descrAutorizac");
          codigoAutorizac.value = ""
          descrAutorizac.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allAutorizac.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrAutorizac: args.descrAutorizac
          }
          const response = await this.props.editAutorizac({
            variables: argsUpd
          });
          const {errors, success} = response.data.editAutorizac;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allAutorizac.refetch()
            this.estadosFalse()
            this.setState({showAutorizac: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteAutorizac({
            variables: argsDel
          });
          this.props.allAutorizac.refetch()
          this.estadosFalse()
          this.setState({showAutorizac: true})
        }
      }
    }
  }

  handlePerfil = async (ev, args)=>{
    if(!args.descrPerfil){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrPerfil){
        argsAdd['descrPerfil'] = "";
        errors.push({path: 'descrPerfil', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addPerfil){
        const response = await this.props.createPerfil({
          variables: args
        });
        const {errors, success} = response.data.createPerfil;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrPerfil = document.getElementById("descrPerfil");
          descrPerfil.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allPerfiles.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          let argsUpd = {
            _id: args._id,
            descrPerfil: args.descrPerfil
          }
          const response = await this.props.editPerfil({
            variables: argsUpd
          });
          const {errors, success} = response.data.editPerfil;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allPerfiles.refetch()
            this.estadosFalse()
            this.setState({showPerfil: true})

            //ACTUALIZA EN usuarios
            let updDoc = [], updDocMany = [], updDocMany1 = []

            let updMatch1 = args.descrPerfilAnt
            let updSet1 = args.descrPerfil
            let argsMatch = `'perfil.descrPerfil': '${updMatch1}'`
            let argsSet = `'perfil.descrPerfil': '${updSet1}'`

            argsUpd = {tipoqry: `{${argsMatch}}, {$set: {${argsSet}}}`, modelo: 'models.Usuario.updateMany'}
            updDoc.push(argsUpd)

            updDoc.forEach((elementoDX, ii) => {
              updDocMany.push(elementoDX)
            })
            updDocMany1.push({docum: updDocMany})

            let numDocCRUD = 0, totDocCRUD = 1, argsCrud = [], crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.updDocumMany)
            }

            argsCrud[numDocCRUD] = updDocMany1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.updDocumMany

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            //FIN ACTUALIZA EN usuarios
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deletePerfil({
            variables: argsDel
          });
          this.props.allPerfiles.refetch()
          this.estadosFalse()
          this.setState({showPerfil: true})
        }
      }
    }
  }

  handlePerfilAut = async (ev, args)=>{
    const errors = [];

    args.forEach((elemento, _id) => {
      if(elemento.estadoAut===false){
        errors.push({path: 'Autorización', message: `La autorización ${elemento.descrAutorizac} esta seleccionado para quitar`});
      }
    })
    if(errors.length>0){
      this.setState({errorAdd: errors})
    }
      if(errors.length===0){
        let arrayAutPerfilIni=this.state.lisAutPerfilIni
        const arrayServ = this.props.allAutorizac.allAutorizac
        let argsUpd, argsDel
        
        let actColecc = [], creaColecc = []

        args.forEach((elemento, _id) => {
          let siExiste = false
          arrayAutPerfilIni.forEach((elemento1, _id) => {
            if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
              siExiste = true
            }
          })
          if(siExiste===false){
            arrayServ.forEach((elemento2, _id) => {
              if(elemento.codigoAutorizac===elemento2.codigoAutorizac){
                argsUpd = {
                  "tipoAct": "EditarAutorizac",
                  "_id": this.state.idLista._id,
                  "codigoAutorizac" : elemento2.codigoAutorizac,
                  "descrAutorizac" : elemento2.descrAutorizac,
                };
                creaColecc.push(argsUpd)
              }
            })
          }
        })

        arrayAutPerfilIni.forEach((elemento, _id) => {
          let siExiste = false
          args.forEach((elemento1, _id) => {
            if(elemento.codigoAutorizac===elemento1.codigoAutorizac){
              siExiste = true
            }
          })
          if(siExiste===false){
            argsDel = {
              "tipoAct": "EliminarAutorizac",
              "_id": this.state.idLista._id,
              "codigoAutorizac": elemento.codigoAutorizac,
            };
            actColecc.push(argsDel)
          }
        })

        let numDocCRUD = 0
        let totDocCRUD = creaColecc.length + actColecc.length
        let argsCrud = [], crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editPerfilUpdDoc)
        }
        creaColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'

          numDocCRUD += 1
        })

        actColecc.forEach((elemento1, ii) => {
          argsCrud[numDocCRUD] = elemento1
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
  
          numDocCRUD += 1
        })

        if(totDocCRUD>0){
          this.updColecc(crudColecc, argsCrud, totDocCRUD)
        }

        this.props.allPerfiles.refetch()
        this.estadosFalse()
        this.setState({showPerfil: true})
      }
    // }
  }

  handleUsuario = async (ev, args, empresa, usuario)=>{
    if(!args.email||!args.nombreUsuario||(!args.claveDeAcceso&&this.state.addUsu)||
    // if((!this.state.permiteDelete&&args.userApp&&(!args.descrOficina||args.descrOficina==="Todas..."))||!args.email||!args.nombreUsuario||(!args.claveDeAcceso&&this.state.addUsu)||
        (args.email==="foroptic@foroptic.com"&&this.state.permiteDelete)||
        !args.descrPerfil||args.descrPerfil==="Seleccionar..."){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(args.email==="foroptic@foroptic.com"&&this.state.permiteDelete){
        argsAdd['foroptic'] = "";
        errors.push({path: 'foroptic', message: "No es posible eliminar el usuario foroptic@foroptic.com" });
      }
      if(!args.email){
        argsAdd['email'] = "";
        errors.push({path: 'email', message: "Debe escribir el correo electrónico"});
      }
      if(!args.nombreUsuario){
        argsAdd['nombreUsuario'] = "";
        errors.push({path: 'nombreUsuario', message: "Debe escribir el nombre del usuario"});
      }
      if(!args.claveDeAcceso&&this.state.addUsu){
          argsAdd['claveDeAcceso'] = "";
          errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso"});
      }
      if(!args.descrPerfil||args.descrPerfil==="Seleccionar..."){
        argsAdd['_id'] = "";
        argsAdd['descrPerfil'] = "Seleccionar...";
        errors.push({path: 'Perfil', message: "Debe seleccionar el perfil"});
      }
      // if(args.userApp&&(!args.descrOficina||args.descrOficina==="Todas...")){
      //   argsAdd['descrOficina'] = "Todas...";
      //   errors.push({path: 'descrOficina', message: "Debe seleccionar la Oficina"});
      // }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addUsu){
        if(!args.descrOficina){
          args['descrOficina'] = "Todas...";
        }
        if(!args.descrTipoRec){
          args['descrTipoRec'] = "Todos...";
        }
        // console.log(args)
        const response = await this.props.createUsuario({
          variables: args
        });
        // console.log("despues")
        const {errors, success} = response.data.createUsuario;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          let email = document.getElementById("email");
          let nombreUsuario = document.getElementById("nombreUsuario");
          let claveDeAcceso = document.getElementById("claveDeAcceso");
          let userApp = document.getElementById("userApp");
          let perfil = document.getElementById("miListaP");
          perfil.options.selectedIndex = 0
          let miLista = document.getElementById("miListaOf");
          miLista.options.selectedIndex = 0
          miLista = document.getElementById("miLista");
          miLista.options.selectedIndex = 0
          miLista = document.getElementById("miLista1");
          miLista.options.selectedIndex = 0
          miLista = document.getElementById("miListaT");
          miLista.options.selectedIndex = 0
          email.value = ""
          nombreUsuario.value = ""
          claveDeAcceso.value = ""
          userApp.checked = false

          this.setState({errorAdd: []})
      
          const argsAdd = {}
          argsAdd['estadoUsuario'] = args.estadoUsuario
          this.setState({argsAdd});
          // this.setState({argsAdd: {}})
          this.props.allUsuarios.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoAct: "EditarUsu",
            nombreUsuario: args.nombreUsuario,
            estadoUsuario: args.estadoUsuario,
            idPerfil: args.idPerfil,
            descrPerfil: args.descrPerfil,
            descrOficina: args.descrOficina,
            _idDpto: args._idDpto,
            codigoDpto: args.codigoDpto,
            descrDpto: args.descrDpto,
            codigoCiudad: args.codigoCiudad,
            nombreCiudad: args.nombreCiudad,
            numeroDocum: args.numeroDocum,
            descrTipoRec: args.descrTipoRec,
            userApp: args.userApp
          }
          const response = await this.props.editUsuario({
            variables: argsUpd
          });
          const {errors, success} = response.data.editUsuario;
          if (!success){
            this.setState({errorAdd: errors})
            
          }else{
            this.props.allUsuarios.refetch()
            this.estadosFalse()
            this.setState({showUsu: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            "_id": args._id,
            "email": args.email
          }
          const response = await this.props.deleteUsuario({
            variables: argsDel
          });
          const {errors, success} = response.data.deleteUsuario;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allUsuarios.refetch()
            this.estadosFalse()
            this.setState({showUsu: true})
          }
        }
      }
    }
  }

  handleCambClave = async (ev, args, usuActivo)=>{
    const argsAdd = this.state.argsAdd
    const errors = [];

    if(!args.claveDeAccesoAct||!args.claveDeAccesoNva1||!args.claveDeAccesoNva2||errors.length>0||
      args.claveDeAccesoNva1!==args.claveDeAccesoNva2||args.claveDeAccesoNva1.length<6){
      if(!args.claveDeAccesoAct){
        errors.push({path: 'Clave de acceso', message: "Debe escribir la clave de acceso ACTUAL"});
      }
      if(!args.claveDeAccesoNva1){
        errors.push({path: 'Clave de acceso', message: "Debe escribir la NUEVA clave de acceso"});
      }else{
        if(args.claveDeAccesoNva1.length<6){
          errors.push({path: 'Clave de acceso', message: "La clave debe ser mayor o igual a 6 caracteres"});
        }
      }
      if(!args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "Debe repetir la NUEVA clave de acceso"});
      }
      if(args.claveDeAccesoNva1!==args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "La NUEVA clave de acceso no coincide al repetirla"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})

    }else{
      const argsUpd = {
        email: sessionStorage.getItem('userLogin'),
        claveDeAcceso: args.claveDeAccesoAct
      }
      const response = await this.props.login({
        variables: argsUpd
      });
      const {success} = response.data.login
      // console.log(token)
      if(!success){
        argsAdd['claveDeAccesoAct'] = "";
        errors.push({path: 'Clave de acceso', message: "Clave de acceso ACTUAL no es válida"});

        this.setState({argsAdd});
        this.setState({errorAdd: errors})
      }else{
        const argsUpd = {
          _id: usuActivo._id,
          tipoAct: "EditarClave",
          claveDeAcceso: args.claveDeAccesoNva1,
        }
        const response = await this.props.editUsuario({
          variables: argsUpd
        });
        const {errors, success} = response.data.editUsuario;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var claveDeAccesoAct = document.getElementById("claveDeAccesoAct");
          var claveDeAccesoNva1 = document.getElementById("claveDeAccesoNva1");
          var claveDeAccesoNva2 = document.getElementById("claveDeAccesoNva2");
          claveDeAccesoAct.value = ""
          claveDeAccesoNva1.value = ""
          claveDeAccesoNva2.value = ""
          this.setState({errorAdd: []})
        }
        this.props.allUsuarios.refetch()
        alert("Nueva clave de acceso actualizada")
      }
    }
  }

  handleCambClaveOU = async (ev, args, argsDocum)=>{
    const argsAdd = this.state.argsAdd
    const errors = [];

    if(!argsDocum.nombreUsuario||argsDocum.nombreUsuario==="Seleccionar..."||!args.claveDeAccesoNva1||!args.claveDeAccesoNva2||errors.length>0||
      args.claveDeAccesoNva1!==args.claveDeAccesoNva2||args.claveDeAccesoNva1.length<6){
      if(!argsDocum.nombreUsuario||argsDocum.nombreUsuario==="Seleccionar..."){
        errors.push({path: 'Usuario', message: "Debe seleccionar el usuario"});
      }
      if(!args.claveDeAccesoNva1){
        errors.push({path: 'Clave de acceso', message: "Debe escribir la NUEVA clave de acceso"});
      }else{
        if(args.claveDeAccesoNva1.length<6){
          errors.push({path: 'Clave de acceso', message: "La clave debe ser mayor o igual a 6 caracteres"});
        }
      }
      if(!args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "Debe repetir la NUEVA clave de acceso"});
      }
      if(args.claveDeAccesoNva1!==args.claveDeAccesoNva2){
        errors.push({path: 'Clave de acceso', message: "La NUEVA clave de acceso no coincide al repetirla"});
      }

      this.setState({argsAdd});
      this.setState({errorAdd: errors})

    }else{
      const argsUpd = {
        _id: argsDocum._id,
        tipoAct: "EditarClave",
        claveDeAcceso: args.claveDeAccesoNva1,
      }
      const response = await this.props.editUsuario({
        variables: argsUpd
      });
      const {errors, success} = response.data.editUsuario;
      if (!success){
        this.setState({errorAdd: errors})
      }else{
        var miLista = document.getElementById("miLista");
        miLista.options.selectedIndex = 0
        var claveDeAccesoNva1 = document.getElementById("claveDeAccesoNva1");
        var claveDeAccesoNva2 = document.getElementById("claveDeAccesoNva2");
        claveDeAccesoNva1.value = ""
        claveDeAccesoNva2.value = ""
        this.setState({errorAdd: []})
      }
      this.props.allUsuarios.refetch()
      alert("Nueva clave de acceso actualizada")
    }
  }

  handlePerfilUsu = () => {
    var miLista = document.getElementById("miListaP");
    const argsAdd = this.state.argsAdd
    argsAdd['descrPerfil'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].value
    this.setState({argsAdd});
  }

  handleCiudadDpto = () => {
    // console.log("55")
    this.setState({argsAdd: {}})
    let miLista = document.getElementById("miLista");
    const argsAdd = this.state.argsAdd
    argsAdd['descrDpto'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text!=="Todos..."){
      argsAdd['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['_idDpto'] = miLista.options[miLista.selectedIndex].value
    }else{
      argsAdd['descrDpto'] = "Todos..."
      argsAdd['codigoDpto'] = "Todos..."
      argsAdd['_idDpto'] = "Todos..."
    }
    argsAdd['codigoCiudad'] = "Todas..."
    argsAdd['nombreCiudad'] = "Todas..."           
    argsAdd['codigoCiudadInterno'] = ""
    argsAdd['codBarrasRdo'] = ""

    this.setState({argsAdd});
  }

  handleZonaCiudad = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Todas..."){
      argsAdd['codigoCiudad'] = "Todas..."
      argsAdd['codigoCiudadInterno'] = ""
      argsAdd['codBarrasRdo'] = ""
    }else{
      argsAdd['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
      argsAdd['codigoCiudadInterno'] = miLista.options[miLista.selectedIndex].attributes[1].value
      argsAdd['codBarrasRdo'] = miLista.options[miLista.selectedIndex].attributes[2].value
    }
    this.setState({argsAdd});
  }

  handleTercero = () => {
    var miLista = document.getElementById("miListaT");
    // console.log(miLista.options[miLista.selectedIndex].value)
    // console.log(miLista.options[miLista.selectedIndex].text)
    const argsAdd = this.state.argsAdd
    argsAdd['numeroDocum'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text==="Todos..."){
      argsAdd['numeroDocum'] = "Todos..."
    }
    this.setState({argsAdd});
  }

  handleTipoRec = () => {
    var miLista = document.getElementById("miListaTR");
    // console.log(miLista.options[miLista.selectedIndex].value)
    // console.log(miLista.options[miLista.selectedIndex].text)
    const argsAdd = this.state.argsAdd
    argsAdd['descrTipoRec'] = miLista.options[miLista.selectedIndex].value
    if(miLista.options[miLista.selectedIndex].text==="Todos..."){
      argsAdd['descrTipoRec'] = "Todos..."
    }
    this.setState({argsAdd});
  }

  handleOficina = () => {
    var miLista = document.getElementById("miListaOf");
    const argsAdd = this.state.argsAdd
    argsAdd['descrOficina'] = miLista.options[miLista.selectedIndex].text
    if(miLista.options[miLista.selectedIndex].text==="Todas..."){
      argsAdd['descrOficina'] = "Todas..."
    }
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    // console.log(idLista)
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showAutorizac) {
      this.setState({verAutorizac: true})
    }
    if (this.state.showPerfil) {
      this.setState({verPerfil: true})
    }
    if (this.state.showUsu) {
      this.setState({verUsu: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({
      permiteUpdate: false,
      permiteDelete: true,
    })
  }

  componentDidUpdate(prevProps){
    if(this.props.allPerfiles.allPerfiles){
      // console.log(this.props.allPerfiles.allPerfiles.length, prevProps.allPerfiles.allPerfiles.length)
      // console.log(this.state.stEntro)
      if((this.props.allPerfiles.allPerfiles!==prevProps.allPerfiles.allPerfiles)){
        // this.setState({stEntro: this.state.stEntro + 1})
        this.props.allPerfiles.refetch()
      }
    }
  }

  render(){
    const {showUser, showAutorizac, addAutorizac, verAutorizac,
      showPerfil, addPerfil, verPerfil, showCambClave, showCambClaveOU, showAutPerfil,
      showUsu, addUsu, verUsu,
      lisAutPerfil, lisAut, lisAutPerfilIni, lisAutIni,
      permiteUpdate, permiteDelete, argsAdd, errorAdd, idLista} = this.state;        

      // console.log(this.state) 
    // console.log(lisAut)
    // console.log(lisAutPerfil)
    let lista = [], lista1 = [], lista2 = [], listaTR = []

    if (this.state.showAutorizac) {
      if(this.props.allAutorizac.allAutorizac){lista = this.props.allAutorizac.allAutorizac}
    }
    if (this.state.showPerfil) {
      if(this.props.allPerfiles.allPerfiles){lista = this.props.allPerfiles.allPerfiles}
    }
    if (this.state.showUsu) {
      if(this.props.allUsuarios.allUsuarios){
        lista = this.props.allUsuarios.allUsuarios
        if(this.props.codigoDptoUA!=="Todos..."){
          lista = lista.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          lista = lista.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA)
        }
      }
    }
    if (this.state.addUsu||this.state.verUsu) {
      // if(this.state.addUsu){
        if(!argsAdd.codigoCiudad&&this.props.codigoCiudadUA==="Todas..."){
          argsAdd['_idDpto'] = "Todos..."
          argsAdd['codigoDpto'] = "Todos..."
          argsAdd['descrDpto'] = "Todos..."
          argsAdd['codigoCiudad'] = "Todas..."
          argsAdd['nombreCiudad'] = "Todas..."           
        }
        if(this.props.allDirmayor.allDirmayor&&this.props.codigoDptoUA!=="Todos..."){
          let listaDir = this.props.allDirmayor.allDirmayor
          listaDir = listaDir.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA)
          argsAdd['codigoDpto'] = listaDir[0].codigoDpto
          argsAdd['descrDpto'] = listaDir[0].descrDpto
          argsAdd['_idDpto'] = listaDir[0]._id
        }

        if(this.props.allDirmayor.allDirmayor){
          lista1 = this.props.allDirmayor.allDirmayor
          if(this.props.codigoCiudadUA!=="Todas..."){
            let listaD = []
            lista1.forEach((elemento, _id) => {
              if(listaD.length===0){
                elemento.ciudades.forEach((elemento1, _id) => {
                  if(elemento1.codigoCiudad===this.props.codigoCiudadUA){
                    listaD.push(elemento)
                  }
                })
              }
            })
            lista1 = listaD
          }
          // console.log(lista1)
        }
        if(!argsAdd.numeroDocum){
          argsAdd['numeroDocum'] = "Todos..."
        }
      // }
// console.log(argsAdd)
      if(this.props.allRecurso.allRecurso){
        lista = this.props.allRecurso.allRecurso
        lista = lista.filter(elemento => elemento.tiporec.areaAprovech==='RECAUDO')
        if(this.props.codigoDptoUA!=="Todos..."){
          lista = lista.filter(elemento => elemento.codigoDpto===this.props.codigoDptoUA||elemento.codigoDpto==="Todos...")
        }
        if(this.props.codigoCiudadUA!=="Todas..."){
          lista = lista.filter(elemento => elemento.codigoCiudad===this.props.codigoCiudadUA||elemento.codigoCiudad==="Todas...")
        }
        if(this.state.verUsu){
          lista.push({_id: 1, numeroDocum: "Todos...", descrRecurso: "Todos..."});
        }
      }
      if(this.props.allOficina.allOficina){
        lista2.push({_id: 0, descrOficina: "Todas..."});
        for(let i=1; i<=this.props.allOficina.allOficina.length; i++){
          lista2.push({_id: i, descrOficina: this.props.allOficina.allOficina[i-1].descrOficina});
        }
      }
      if(this.props.allTipoRec.allTipoRec){
        listaTR = this.props.allTipoRec.allTipoRec
        listaTR = listaTR.filter(elemento => elemento.areaAprovech==='TECNICA')
        if(this.state.verUsu){
          listaTR.push({_id: 1, descrTipoRec: "Todos..."});
        }
      }
    }

    let usuActivo = {}
    if(this.props.allUsuarios.allUsuarios){
      usuActivo = this.props.allUsuarios.allUsuarios.filter(usuario => usuario.email===sessionStorage.getItem('userLogin'))
    }

    if (this.state.showCambClaveOU) {
      if(this.props.allUsuarios.allUsuarios){
        lista = this.props.allUsuarios.allUsuarios
      }
    }

    // console.log(sessionStorage.getItem('userLogin'))
    
    // console.log(lista)
// console.log(this.state.idLista)
// console.log(this.props.allOferta.allOferta)
    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showUser && <HomeUser1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickSel1={this.showAutorizac}
                          handleClickSel2={this.showPerfil} handleClickSel3={this.showUsu}
                          handleClickSel4={this.showCambClave} handleClickSel5={this.showCambClaveOU}/>}

            {showAutorizac && <UserAut1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {addAutorizac && <AddAut1 styles={this.props.styles} handleClickRegr={this.showAutorizac}/>}
            {verAutorizac && <VerAut1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showAutorizac} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showPerfil && <UserPerfil1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {addPerfil && <AddPerfil1 styles={this.props.styles} handleClickRegr={this.showPerfil}/>}
            {verPerfil && <VerPerfil1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                          handleClickRegr={this.showPerfil} handleClickUpd={this.handleClickUpd}
                          handleClickDel={this.handleClickDel} handleClickSel1={this.showAutPerfil}/>}

            {showAutPerfil && <UserAutP1 styles={this.props.styles} handleClickRegr={this.showPerfil}/>}

            {showUsu && <UserUsu1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {addUsu && <AddUsu1 styles={this.props.styles} handleClickRegr={this.showUsu}/>}
            {verUsu && <VerUsu1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClickRegr={this.showUsu} handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showCambClave && <CambClave1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
            {showCambClaveOU && <CambClaveOU1 styles={this.props.styles} handleClickRegr={this.showUser}/>}
          </div>
          <div className="column" style={this.props.styles.boxDer}>
            {showUser && <HomeUser2 styles={this.props.styles}/>}

            {showAutorizac && <UserAut2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addAutorizac} list={lista} handleClickidLista={this.idLista}/>}
            {addAutorizac && <AddAut2 styles={this.props.styles} handleSubmit={this.handleAutorizac} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verAutorizac && <VerAut2 styles={this.props.styles} handleSubmit={this.handleAutorizac} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showPerfil && <UserPerfil2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} handleClick={this.addPerfil} list={lista} handleClickidLista={this.idLista}/>}
            {addPerfil && <AddPerfil2 styles={this.props.styles} handleSubmit={this.handlePerfil} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verPerfil && <VerPerfil2 styles={this.props.styles} handleSubmit={this.handlePerfil} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} handleClickSel1={this.showAutPerfil}/>}

            {showAutPerfil && <UserAutP2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                lisAutPerfil={lisAutPerfil} lisAut={lisAut} lisAutIni={lisAutIni} lisAutPerfilIni={lisAutPerfilIni} handleVrinic={this.showAutPerfil} perfil={idLista.descrPerfil} errors={errorAdd} handleSubmit={this.handlePerfilAut}/>}

            {showUsu && <UserUsu2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleClick={this.addUsu} list={lista} handleClickidLista={this.idLista}/>}
            {addUsu && <AddUsu2 styles={this.props.styles} handleSubmit={this.handleUsuario}
              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
              handleListaOf={this.handleOficina} handleListaP={this.handlePerfilUsu}
              handleLista={this.handleCiudadDpto} handleLista1={this.handleZonaCiudad}
              handleListaT={this.handleTercero} handleListaTR={this.handleTipoRec}
              handleChange={this.handleChange} args={argsAdd}
              errors={errorAdd} list={lista} list1={lista1} list2={lista2} listTR={listaTR}/>}
            {verUsu && <VerUsu2 styles={this.props.styles} handleSubmit={this.handleUsuario}
              handleChange={this.handleChange} args={argsAdd} errors={errorAdd} idLista={idLista}
              codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
              permiteUpdate={permiteUpdate} permiteDelete={permiteDelete} list={lista}
              list1={lista1} list2={lista2} listTR={listaTR}/>}

            {showCambClave && <CambClave2 styles={this.props.styles} usuActivo={usuActivo} handleSubmit={this.handleCambClave} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} handleClickRegr={this.showUser}/>}
            {showCambClaveOU && <CambClaveOU2 styles={this.props.styles} usuActivo={usuActivo} list={lista} handleSubmit={this.handleCambClaveOU} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} handleClickRegr={this.showUser}/>}
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allAutorizac, {name:'allAutorizac', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createAutorizac, {name:'createAutorizac'}),
  graphql(queries.mutation.editAutorizac, {name:'editAutorizac'}),
  graphql(queries.mutation.deleteAutorizac, {name:'deleteAutorizac'}),

  graphql(queries.query.allPerfiles, {name:'allPerfiles', options: (props) => {return {variables: {}}}}),
  graphql(queries.mutation.createPerfil, {name:'createPerfil'}),
  graphql(queries.mutation.editPerfil, {name:'editPerfil'}),
  graphql(queries.mutation.editPerfilUpdDoc, {name:'editPerfilUpdDoc'}),
  graphql(queries.mutation.deletePerfil, {name:'deletePerfil'}),

  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.mutation.createUsuario, {name:'createUsuario'}),
  graphql(queries.mutation.editUsuario, {name:'editUsuario'}),
  graphql(queries.mutation.deleteUsuario, {name:'deleteUsuario'}),

  graphql(queries.mutation.login, {name:'login'}),

  graphql(queries.query.allDirmayor, {name:'allDirmayor', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allRecurso, {name:'allRecurso', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allOficina, {name:'allOficina', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allOficina, {name:'allOficina'}),
  graphql(queries.mutation.updDocumMany, {name:'updDocumMany'}),

  graphql(queries.query.allTipoRec, {name:'allTipoRec'}),

  // graphql(queries.query.allPagoClientes, {name:'allPagoClientes', options: (props) => {return {variables: {}}}}),
  // graphql(queries.query.allClientes, {name:'allClientes', options: (props) => {return {variables: {numDocum: 1}}}}),
  // graphql(queries.mutation.editPagoClientesUpdDoc, {name:'editPagoClientesUpdDoc'}),

  // graphql(queries.query.allDetalleDX, {name:'allDetalleDX', options: (props) => {return {variables: {numeroOdeDX: 4}}}}),
  // graphql(queries.mutation.editClienteMany, {name:'editClienteMany'}),

  // graphql(queries.query.allOdeSRtes, {name:'allOdeSRtes', options: (props) => {return {variables: argsBuscarOS}}}),
  // graphql(queries.query.allFacturacion, {name:'allFacturacion', options: (props) => {return {variables: {}}}}),
  // graphql(queries.mutation.createFacturacionMany, {name:'createFacturacionMany'}),
  // graphql(queries.mutation.deleteFacturacion, {name:'deleteFacturacion'}),
  
  )(HomeUser)
